
import React from 'react';

interface VideoFile {
  url: string;
  type?: string;
  mimeType?: string;
}

interface ExhibitVideoProps {
  video: VideoFile;
}

const ExhibitVideo = ({ video }: ExhibitVideoProps) => {
  return (
    <div className="mb-4">
      <div className="aspect-w-16 aspect-h-9 rounded-lg overflow-hidden">
        <video
          src={video.url}
          controls
          className="w-full h-full object-cover"
          preload="metadata"
        />
      </div>
    </div>
  );
};

export default ExhibitVideo;
